import $axios from "@/service/httpServer";

export const requestQrcode = (p) => $axios.post('/Web/Backend/CommonLogin/requestQrcode', p);
export const queryQrcodeResult = (p) => $axios.post('/Web/Backend/CommonLogin/queryQrcodeResult', p);
